// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//Built off of https://vuejs-templates.github.io/webpack/

import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

//Http Request Library
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import VeeValidate from "vee-validate";
import VueGoodTable from "vue-good-table";
import Paginate from "vuejs-paginate";
import Snotify, { SnotifyPosition } from "vue-snotify";
import tinymce from '@/lib/tinymce/tinymce.js';
import Tooltip from "vue-directive-tooltip";
import Print from "vue-print-nb";
// import Scripts from "@/lib/others/Scripts.js";

import "font-awesome/css/font-awesome.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-snotify/styles/material.css";
import "vue-directive-tooltip/css/index.css";
import "../styles/main.scss";

import { webAuth } from "./auth/index";
import VCalendar from "v-calendar";

//Show Production Tip if in Development
Vue.config.productionTip = process.env.NODE_ENV == "development";

//Setup Axios
Vue.http = Vue.prototype.$http = axios.create({
  baseURL: process.env.MOTOFUZE_API
});

window.isPlugin = window.location.hash.toLowerCase().indexOf("plugin") > -1;

Vue.http.interceptors.request.use(async function(config) {
  const user = await webAuth.getUser();
  if (!window.isPlugin) {
    if (user && !user.expired) {
      config.headers = {
        Authorization: store.getters.AuthorizationHeader,
        "Content-Type": "application/json"
      };
      return config;
    } else {
      sessionStorage.setItem("lastRoute", window.location);
      webAuth.signinRedirect();
      return Promise.reject("User Expired");
    }
  } else {
    console.log("plugin request");
    config.headers = {
      Authorization: store.getters.AuthorizationHeader
    };
    return config;
  }
});

//  Vue.http.interceptors.response.use(function(response){
//   return response;
//  }, function(error){
//   let originalRequest = error.config;
//   if(error.response.status === 401){
//    return Promise.reject('UNAUTHORIZED')
//   }
//  })

Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(VueGoodTable);
Vue.use(Paginate);
Vue.use(Tooltip);
Vue.use(Print);

// Setup Vue-Snotify for notifications
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    titleMaxLength: 200,
    bodyMaxLength: 500,
    showProgressBar: false
  }
};
Vue.use(Snotify, options);

Vue.use(VCalendar, {
  firstDayOfWeek: 1
});

/* Setup tinymce editor */
tinymce.loadScripts();

// Load other scripts
// Scripts.loadScripts();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js